import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "topnav sticky top-0 left-0 w-full py-3 px-default bg-bg_secondary z-50 h-[70px] flex justify-between items-center gap-6" }
const _hoisted_2 = { class: "flex justify-end items-center h-full w-full" }
const _hoisted_3 = {
  type: "submit",
  class: "text-primary_1"
}

import { ref } from "vue";
import Logo from "./Logo.vue";
import { Icon } from "@iconify/vue";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopNav',
  setup(__props) {

const searchTerms = ref("");

const handleSubmit = () => {
  router.push({ name: "Search", params: { searchTerms: searchTerms.value } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$route.path.includes('watch') ? 'md:block' : 'md:hidden')
    }, [
      _createVNode(Logo)
    ], 2),
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("form", {
        class: "flex items-center rounded-full bg-white pr-3",
        onSubmit: _withModifiers(handleSubmit, ["prevent"])
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          name: "search",
          id: "search",
          class: "py-2 px-5 w-full max-w-sm outline-none bg-transparent text-black",
          placeholder: "Search",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerms).value = $event))
        }, null, 512), [
          [_vModelText, searchTerms.value]
        ]),
        _createElementVNode("button", _hoisted_3, [
          _createVNode(_unref(Icon), {
            icon: "ic:sharp-search",
            class: "text-3xl"
          })
        ])
      ], 32)
    ])
  ]))
}
}

})